export const isMachineNeedSync = (machineData: any) => {
  return Number(machineData.status) === 0
}
